var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade", appear: "" } }, [
    _c("div", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.overlay,
          expression: "overlay",
        },
      ],
      ref: "overlay",
      staticClass: "overlay",
      on: { click: _vm.close },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }